import React from 'react';
import PropTypes from 'prop-types';
import ReactSVG from 'react-svg';
import sh from '../../../../helpers/string.helper';
import './styles.css';

const SearchedItem = ({
  item,
  startChatCallback,
  getChannelName,
}) => (
  <a
    href="#"
    className="msg-search-link searched-item-link"
    onClick={(e) => { startChatCallback(e, item); }}
  >
    <div className="searched-item-part">
      <p className="msg-search-chat">{getChannelName(item)}</p>
      <span className="msg-search-content  three-dots">{sh.html2text(item.content)}</span>
    </div>
    <ReactSVG className="msg-search-img" src="/img/arrowright.svg" style={{ width: '20px' }} />
  </a>
);

SearchedItem.propTypes = {
  startChatCallback: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default SearchedItem;



// WEBPACK FOOTER //
// ./src/views/modules/messages/SearchedItem/SearchedItem.js